import { atom } from 'jotai'
import { industryThemes } from '@/libs/theme'
import { atomWithStorage } from 'jotai/utils'

export const themeKeyAtom = atomWithStorage('themeKey', 'default')

export const themeConfigAtom = atom(get => industryThemes[get(themeKeyAtom)])
